export default __webpack_public_path__ + "static/media/TKH_Logo.d7f422af.png";